<h1 mat-dialog-title data-testid="change-ext-dataset-dialog">
  <i class="far fa-exclamation-triangle i-16 mr-4"></i>
  <span>Dataset Change</span>
</h1>
<div mat-dialog-content class="text-center">
  <div class="c-grey-5 fs-14 justify-content-center d-flex w-100p">
      Changing Dataset will reset the visualization, removing all selected fields and filters!
  </div>
  <p class="c-grey-5 fs-14 bold mb-25">Do you wish to continue?</p>
</div>
<div mat-dialog-actions class="buttons-section m-0" align="center">
  <button trgButton color="outline" class="min-w-100" [mat-dialog-close]="false" data-testid="change-ext-dataset-dialog-cancel">Close</button>
  <button trgButton color="primary" class="min-w-100" (click)="close(true)" cdkFocusInitial data-testid="change-ext-dataset-dialog-continue">
    Continue
  </button>
</div>